export enum EUnfulfillmentEventTag {
    NOTIFICATIONS_OFF = 'NOTIFICATIONS_OFF',
    UNDELIVERED_MESSAGE = 'UNDELIVERED_MESSAGE',
    INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
    UNREAD_MESSAGE = 'UNREAD_MESSAGE',
    INSUFFICIENT_DELIVERY_INFORMATION = 'INSUFFICIENT_DELIVERY_INFORMATION',
    NOTIFICATIONS_OFF_WHATSAPP = 'NOTIFICATIONS_OFF_WHATSAPP',
    NOT_DRIVER_MOVEMENT = 'NOT_DRIVER_MOVEMENT',
}

export enum TEventTagName {
    INSPECTOR_EVENT = 'Inspector Event',
}

export type TEventTag = {
    key: TEventTagName;
    color: string;
}
